<template>
  <spring-spinner
    :style="styleSpiner"
    :color="$themes.primary"
    v-if="isLoading"
  />
  <div class="row flex-center" v-else>
    <div class="flex xs12 xl6">
      <va-card
        :title="
          ''
        "
      >

        <ul>
          <li>
            <div :style="{background: `var(--va-${statusesColor[order.status]})`,color: 'white',padding:'5px', textAlign: 'center'}">
              {{statuses[order.status]}}
            </div>
          </li>

          <li>
            <span>{{ $t("orders.rental_period") }}:</span>
            <strong>from</strong>:{{ moment(order.rental_period.start_at).format('L') }},
            <strong>to</strong>: {{moment(order.rental_period.end_at).format('L')}}
          </li>
          <li>
            <span>{{ $t("orders.borrower") }}:</span>
            <router-link :to="{ name: 'user-single', params: { id: order.borrower.id } }">
              {{order.borrower.get_full_name}} <img :src="order.borrower.avatar" :style="{width: '50px',height:'50px'}" alt="">
            </router-link>
          </li>
          <li>
            <span>{{ $t("orders.publication")}}:</span>
            <router-link :to="{name: 'publications-single', params:{id:order.publication.id}}">
              {{order.publication.title}}
              <img :src="order.publication.image" :style="{width: '50px',height:'50px'}" alt="">
            </router-link>
          </li>
          <li>
            <span>{{ $t("orders.lander")}}:
              <router-link :to="{ name: 'user-single', params: { id: order.publication.lender.id } }">
                {{order.publication.lender.get_full_name}} <img :src="order.publication.lender.avatar" :style="{width: '50px',height:'50px'}" alt="">
              </router-link>
            </span>
          </li>
          <li>
            <span>{{ $t("orders.transaction")}}:</span>
            <ul :style="{marginLeft:'20px'}">
              <li v-for="(tranItem,key) in order.transaction" :key="tranItem">
                <span v-if="key === 'status'"></span>

                <span v-else>{{ $t(`orders.${key}`)}}: <strong>{{tranItem}}$</strong></span>
              </li>
            </ul>
          </li>

          <li>
            <span>{{ $t("orders.subtotal_price") }}:</span>{{order.subtotal_price}}$
          </li>
          <li>
            <span>{{ $t("orders.discount") }}:</span>{{order.discount}}$
          </li>
          <li>
            <span>{{ $t("orders.total_price") }}:</span>{{order.total_price}}$
          </li>
          <li>
            <span>{{ $t("orders.borrower_highlight") }}:</span>
            <i> {{ order.borrower_highlight ? "✔️" : "❌" }}</i>
          </li>
          <li>
            <span>{{ $t("orders.lender_highlight") }}:</span>
            <i> {{ order.lender_highlight ? "✔️" : "❌" }}</i>
          </li>
          <li>
            <span>{{ $t("orders.created_at") }}:</span>{{order.created_at?moment(order.created_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.updated_at") }}:</span>{{order.updated_at?moment(order.updated_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.approved_at") }}:</span>{{order.approved_at?moment(order.approved_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.declined_at") }}:</span>{{order.declined_at?moment(order.declined_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.cancelled_at") }}:</span>{{order.cancelled_at?moment(order.cancelled_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.sent_at") }}:</span>{{order.sent_at?moment(order.sent_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.received_at") }}:</span>{{order.received_at?moment(order.received_at).format('L'):'-'}}
          </li>
          <li>
            <span>{{ $t("orders.returned_at") }}:</span>{{order.returned_at?moment(order.returned_at).format('L'):'-'}}
          </li>
        </ul>
      </va-card>
    </div>
    <!-- <div class="flex xs12 xl6">
      <va-card
        :title="
          ''
        "
      >
      </va-card>
    </div> -->
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { SpringSpinner } from 'epic-spinners'
import moment from 'moment'
export default {
  data() {
    return {
      isLoading: true,
      rogo_fee: null,
      order: {},
      statuses: {
        0: 'AWAITING',
        1: 'APPROVED',
        '-1': 'DECLINED',
        2: 'SENT',
        3: 'RECEIVED',
        4: 'RETURNED',
        '-2': 'NONE',
      },
      statusesColor: {
        0: 'warning',
        1: 'success',
        '-1': 'danger',
        2: 'info',
        3: 'success',
        4: 'primary',
        '-2': 'gray',
      },
    }
  },
  components: { SpringSpinner },
  computed: {
    orderID() {
      return this.$route.params.id
    },
    styleSpiner() {
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }
    },
    styleAvatar() {
      return {
        maxWidth: '100px',
      }
    },
  },
  methods: {
    async deletingOrder({ data, clear }) {
      const ask = data?.deleting && confirm('Are you sure? Do you want to delete this order?')
      this.skipLoading = true

      if (ask || !data?.deleting) {
        const res = await this.deleteOrder(data)
        if (res.data?.ok) {
          await this.setOrder(false)
          this.showToast(
            res.data?.ok,
            {
              icon: 'fa-check',
              position: 'bottom-right',
              duration: 2500,
              fullWidth: false,
            },
          )
        } else {

        }
        clear()
        this.skipLoading = false
      }
      // this.$router.go(-1)
    },
    ...mapActions('Orders', ['getOrder', 'block', 'unBlock', 'sendNotification', 'setFee', 'deleteOrder']),
    async editSettings(key) {
      const body = { id: this.order.id }
      body[key] = this[key]
      this.setFee(body)
      this.order[key] = body[key]
    },
    moment,
    async sendBan(data) {
      await this.block({ id: this.orderID, data })
      this.setOrder(false)
    },
    async setOrder(isLoading = true) {
      this.isLoading = isLoading
      const response = await this.getOrder(this.orderID)
      this.order = response.data
      this.rogo_fee = this.order.rogo_fee
      this.isLoading = false
      if (response.status !== 200) {
        this.$router.push({ name: 'orders' })
      }
    },
    async unBlockOrder(id) {
      await this.unBlock(id)
      this.setOrder(false)
    },
  },
  created() {
    this.setOrder()
  },
}
</script>
<style lang="scss" scoped>
ul {
  li {
    font-size: 20px;

    span {
      font-weight: 600;
    }
  }

  .ban {
    padding: 15px;
    border: 1px solid var(--va-textColor);

    &:not(:last-child) {
      border-bottom: none;
    }
  }
}
</style>
